import React from "react";
import { useForm } from "react-hook-form";
import { useApi } from "@tiny/api";
import { useMessages } from "@tiny/components";
import { AddSuppressionDialogProps } from "./AddSuppressionDialog";
import { suppressionTypes } from "./AddSuppressionDialog.helpers";

interface FormValues {
  name: string;
  type: typeof suppressionTypes[0];
}

export function useAddSuppressionDialog(props: AddSuppressionDialogProps) {
  const api = useApi();
  const { onClose, onSuccess } = props;

  const form = useForm<FormValues>();

  const { showErrorMessage } = useMessages();

  const [executing, setExecuting] = React.useState(false);

  const [isGlobal, setIsGlobal] = React.useState(false);

  const handleSubmit = React.useCallback(
    async (values: FormValues) => {
      setExecuting(true);
      try {
        const { data } = await api.getSuppressionCheckExistsBySuppressionName(
          values.name
        );
        if (data?.exist) {
          form.setError("name", {
            type: "validate",
            message: "Suppression with this name already exists!",
          });
        } else {
          const payload = {
            ...values,
            type: values.type.value,
            scope: isGlobal ? "GLOBAL" : "LOCAL",
          };
          onSuccess(payload);
          onClose();
        }
      } catch (e: any) {
        showErrorMessage(
          "An error occurred while checking the suppression existence."
        );
      } finally {
        setExecuting(false);
      }
    },
    [form, onClose, onSuccess, showErrorMessage, isGlobal]
  );

  const continueAdding = React.useCallback(() => {
    form.handleSubmit(handleSubmit)();
  }, [form, handleSubmit]);

  return {
    form,
    handleSubmit,
    continueAdding,
    executing,
    isGlobal,
    setIsGlobal,
  };
}
